import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const ROLE = {
  INVENTORY: 'inventory',
  MAINTENANCE: 'maintenance',
  MANAGE: 'manage',
  ADMIN: 'admin'
}

class Grant extends React.PureComponent {
  render() {
    return (
      _.isObject(this.props.authorizations)
      &&
      _.has(this.props.authorizations, this.props.role)
      &&
      !!this.props.authorizations[this.props.role]
        ? this.props.children
        : null
    )
  }
}

Grant.propTypes = {
  // Properties
  role: PropTypes.oneOf([
    ROLE.INVENTORY,
    ROLE.MAINTENANCE,
    ROLE.MANAGE,
    ROLE.ADMIN
  ]).isRequired,

  // Redux State
  authorizations: PropTypes.object
}

Grant.ROLE = ROLE

export default connect(
  (state) => ({
    authorizations: state.app.identity.user && state.app.identity.user.authorizations
  }),
  (dispatch) => ({
    // Nothing
  })
)(Grant)



// WEBPACK FOOTER //
// ./src/containers/elements/Grant.js